<template>
  <div :class="{ 'sidebar-position-saved': true }">
    <SidebarTopRightOrientation>
      <div class="sidebar-top-right-orientation__right">
        <button
          @click="closeSidebarPositionSaved"
          class="sidebar-top-right-orientation__button"
        >
          <div class="sidebar-top-right-orientation__button__text">Sluit</div>
          <svg class="sidebar-top-right-orientation__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        </button>
      </div>
    </SidebarTopRightOrientation>

    <div class="sidebar-position-saved__bottom">
      <div class="sidebar-position-saved__infobar">
        <div class="sidebar-position-saved__infobar-inner">
          <div class="sidebar-position-saved__infobar-left">
            <div
              class="sidebar-position-saved__infobar-title"
              :style="{ color: appAsset ? appAsset.color_primary : '#101010' }"
            >
              Klaar!
            </div>
          </div>
          <div class="sidebar-position-saved__infobar-right">
            <div
              class="sidebar-position-saved__infobar-right-text"
              @click="closeSidebarPositionSaved"
              :style="{ color: appAsset ? appAsset.color_primary : '#101010' }"
            >
              Gereed
            </div>
          </div>
        </div>
      </div>
      <template v-if="landscapeUrl">
        <img class="sidebar-position-saved__image" :src="landscapeUrl" alt="" />
      </template>
      <div class="sidebar-position-saved__image-under">
        <div class="sidebar-position-saved__body-text">
          Locatie toegevoegd! Met het in het gebruik nemen van deze app gaat u
          akkoord met onze gebruiksvoorwaarden.
        </div>
        <a
          target="_blank"
          href="https://www.omgevingsalert.nl/voorwaarden"
          class="sidebar-position-saved__button"
        >
          Bekijk algemene voorwaarden
        </a>
      </div>
    </div>
    <portal to="page-shadow">
      <PageShadow />
    </portal>
  </div>
</template>

<script>
import PageShadow from "@/components/PageShadow.vue";
import SidebarTopRightOrientation from "@/components/SidebarTopRightOrientation.vue";

export default {
  components: {
    PageShadow,
    SidebarTopRightOrientation
  },
  data() {
    let activeMunicipality = this.$store.state.ui.activeMunicipality;
    return {
      landscapeUrl: activeMunicipality.app_asset
        ? activeMunicipality.app_asset.splash_landscape_url
        : null,
      appAsset: activeMunicipality.app_asset
        ? activeMunicipality.app_asset
        : null
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.appAsset ? this.appAsset.color_primary : "#6DCC00",
          vmid: "theme-color"
        }
      ]
    };
  },
  methods: {
    closeSidebarPositionSaved() {
      this.$store.commit("closeSidebarPositionSaved");
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-position-saved {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;

  &__infobar {
    border-bottom: 1px solid #efefef;
    background: #fff;
    padding: 0 $spacing-3;
    height: 64px;
  }

  &__infobar-inner {
    display: flex;
    align-items: center;
  }

  &__infobar-left {
  }

  &__infobar-title {
    @extend %text-title-2;
    line-height: 64px;
  }

  &__infobar-right {
    margin-left: auto;
  }

  &__infobar-right-text {
    margin-left: auto;
    @extend %text-small;
    line-height: 64px;
    cursor: pointer;
  }

  &__image {
    padding: $spacing-3;
    background: #fff;
  }

  &__image-under {
    padding: $spacing-3;
    background: #fff;
  }

  &__body-text {
    @extend %text-medium;
  }

  &__bottom {
    flex: 1;
    overflow-y: auto;
  }

  &__button {
    display: inline-block;
    color: $color-black-1;
    width: 100%;
    @extend %text-medium;
    margin-top: $spacing-4;
    height: 48px;
    padding: 0 $spacing-4;
    line-height: 48px;
    border-radius: 6px;
    background-color: $color-gray-2;
    transition: background-color $easing-1;

    &:hover {
      background-color: darken($color-gray-2, 5%);
    }
  }
}

@media (min-width: 768px) {
  .sidebar-position-saved {
    &__infobar {
      padding: 0 $spacing-4;
    }
    &__image {
      padding: $spacing-4;
    }
    &__image-under {
      padding: $spacing-4;
    }
  }
}
</style>
